// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {
  Form, FormItem, Input, Message, Backtop, Icon, Collapse, CollapseItem, Loading
} from 'element-ui'
import http from './api/http.js'
import 'element-ui/lib/theme-chalk/index.css'
import MetaInfo from 'vue-meta-info'
import 'lib-flexible/flexible'

Vue.config.productionTip = false
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Backtop)
Vue.use(Icon)
Vue.use(MetaInfo)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading)

Vue.prototype.$message = Message
Vue.prototype.$https = http
Vue.prototype.$imgBaseUrl = 'http://wxsmjphoto.wanjiejixie.com'
Vue.prototype.$requesturl = 'http://gadmin.wanjiejixie.com/api/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js